import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { whatsappLink } from "@/constants/site";
import { siteCases } from "@/mocks/sites";

export default function SiteCases() {
  return (
    <section id="cases" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Cases de clientes"
          badgeIcon="ri-medal-line"
          badgeTone="secondary"
          title="Histórias de empresas que cresceram online."
          description="Entenda o desafio, a solução que construímos e o que mudou para o negócio de cada cliente."
        />

        <div className="mt-12 flex flex-col gap-6">
          {siteCases.map((item, index) => (
            <Reveal key={item.client} delay={index * 80}>
              <article className="grid grid-cols-1 gap-6 rounded-2xl border border-background-200 bg-background-50 p-6 md:grid-cols-3 md:gap-8 md:p-8">
                <div className="md:border-r md:border-background-200 md:pr-8">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
                    <i className="ri-building-2-line text-2xl" aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                    {item.client}
                  </h3>
                  <p className="mt-1 text-xs font-medium uppercase tracking-wide text-foreground-400">
                    {item.segment}
                  </p>
                  <div className="mt-5 flex flex-wrap gap-2">
                    {item.results.map((result) => (
                      <span
                        key={result.label}
                        className="inline-flex items-center gap-1.5 rounded-full bg-secondary-50 px-3 py-1 text-[11px] font-medium text-secondary-800"
                      >
                        <i className={result.icon} aria-hidden="true"></i>
                        {result.label}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="md:col-span-2">
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-wider text-foreground-400">
                      O desafio
                    </p>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                      {item.challenge}
                    </p>
                  </div>
                  <div className="mt-5">
                    <p className="text-xs font-semibold uppercase tracking-wider text-foreground-400">
                      O que fizemos
                    </p>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                      {item.solution}
                    </p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-xl border border-background-200 bg-background-50 p-6 text-center sm:flex-row sm:text-left">
            <div>
              <p className="font-heading text-base font-semibold text-foreground-950">
                Quer um site assim para a sua empresa?
              </p>
              <p className="mt-1 text-sm text-foreground-600">
                Conte o seu desafio e a gente mostra o melhor caminho.
              </p>
            </div>
            <a
              href={whatsappLink("Ola! Vi o portfolio da NXHOST e quero um site para a minha empresa.")}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-whatsapp-line text-lg" aria-hidden="true"></i>
              Quero um site assim
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}